import { render, staticRenderFns } from "./Provision.vue?vue&type=template&id=68fcfda1&scoped=true&"
import script from "./Provision.vue?vue&type=script&lang=js&"
export * from "./Provision.vue?vue&type=script&lang=js&"
import style0 from "./Provision.vue?vue&type=style&index=0&id=68fcfda1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fcfda1",
  null
  
)

export default component.exports